var ajaxCalls = require('./ajaxCalls');

var save = function(exam,global) {

    var modalDiv = $('#'+ global.modal);
    $(modalDiv).on('hidden.bs.modal', function (e) {
        // update the answer
        var answer = global.response.answers[global.questionIndex];
        ajaxCalls.updateAnswer(global.userId,global.examId,answer);
        $(modalDiv).find('.modal-content').html('');
        document.location.href = global.dashboardLink;
    });
    var modalcontentstr = '<div class="modal-header">Save</div><div class="modal-body">' +
        'Your practice exam has be saved. You can resume from the dashboard.';

    modalcontentstr += '</div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal">Return to Dashboard</button></div>';
    var modalContent = $.parseHTML(modalcontentstr);

    $(modalDiv).find('.modal-content').append(modalContent);
    $(modalDiv).modal();

}

module.exports = save;


//////////////////
// WEBPACK FOOTER
// ./src/save.js
// module id = 318
// module chunks = 0